import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function NewOrgDialog({ open, onOpenChange }) {
  const { refreshOrgs, switchOrg } = useAuth();
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!name.trim()) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/organizations", { name: name.trim(), fiscal_year_start_month: 1, currency: "USD" });
      await refreshOrgs();
      switchOrg(data.id);
      toast.success(`Created “${data.name}”`);
      setName("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="new-org-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">New organization</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <Label htmlFor="org-name">Organization name</Label>
          <Input
            id="org-name"
            data-testid="new-org-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Hope Community Church"
            autoFocus
          />
          <p className="text-xs text-muted-foreground">
            A fresh set of default income & expense categories will be created for you.
          </p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="new-org-cancel">
            Cancel
          </Button>
          <Button onClick={submit} disabled={submitting || !name.trim()} data-testid="new-org-create">
            {submitting ? "Creating…" : "Create"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
